<template>
  <div class="dashboard-modern">
    <NavBar
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
    />

    <AuthBySessionExpired />

    <div
      v-if="
        terms == 1 &&
        (geolocation == 0 || (geolocation == 1 && terms_geolocation == 1))
      "
      class="dashboard-container"
    >
      <!-- Header Section -->
      <div class="dashboard-header">
        <div class="header-content">
          <h1 class="dashboard-title">Residentes</h1>
          <div class="header-stats">
            <div
              v-if="$store.state.online && duty && permission('write', 'duty')"
            >
              Plantão iniciado no dia {{ formatDate(duty.created_at) }}
              <v-btn class="btn-finish-modern" @click="openModal">
                <i class="fas fa-briefcase-medical mr-2"></i>
                <span>Finalizar Plantão</span>
              </v-btn>
            </div>

            <v-btn
              v-if="$store.state.online && !duty && permission('write', 'duty')"
              class="btn-add-modern"
              @click="openModal"
            >
              <i class="fas fa-briefcase-medical mr-2"></i>
              <span>Iniciar Plantão</span>
            </v-btn>

            <div class="stat-item">
              <span class="stat-number">{{ total }}</span>
              <span class="stat-label">Total</span>
            </div>
          </div>
        </div>

        <Duty @checkPeriodDuty="checkPeriodDuty" :duty="duty" />

        <!-- Security Questions Alert -->
        <div
          v-if="!loading && missing_security_questions"
          class="security-alert mt-2"
        >
          <div class="alert-content">
            <i class="fas fa-exclamation-triangle alert-icon"></i>
            <span class="alert-text">
              Verifique as questões de segurança para liberar o acesso OFFLINE!
            </span>
            <button
              @click="
                $router.push({
                  name: 'account',
                  query: { question_answer: true },
                })
              "
              class="alert-button"
            >
              Configurar
            </button>
          </div>
        </div>
      </div>

      <!-- Filters Section -->
      <div class="filters-section" v-if="$store.state.online">
        <div class="filters-grid">
          <!-- Gender Filter -->
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-filter filter-icon"></i>
              Gênero
            </label>
            <v-select
              dense
              :items="genders"
              v-model="gender"
              outlined
              hide-details
              class="modern-select"
              @change="getResidents"
            />
          </div>

          <!-- Search -->
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-search filter-icon"></i>
              Pesquisar
            </label>
            <v-text-field
              dense
              placeholder="Nome do residente"
              outlined
              hide-details
              v-model="name"
              class="modern-input"
              @input="getResidents"
            />
          </div>

          <!-- Care Filter -->
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-heart filter-icon"></i>
              Cuidados
            </label>
            <v-select
              dense
              :items="typesFilterByCare"
              v-model="filterCare"
              outlined
              hide-details
              class="modern-select"
              @change="handleFilterByCare"
            />
          </div>

          <!-- Dependency Grade -->
          <div class="filter-group">
            <label class="filter-label">
              <i class="fas fa-chart-line filter-icon"></i>
              Dependência
            </label>
            <v-select
              dense
              :items="typesFilterByGrau"
              v-model="degree_of_dependence_id"
              outlined
              hide-details
              class="modern-select"
              @change="getResidents"
            />
          </div>
        </div>
      </div>

      <!-- Residents Grid -->
      <div class="residents-section">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <div class="residents-grid">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="resident-card"
            >
              <!-- Card Header -->
              <div class="card-header" @click="handleToResident(resident.id)">
                <div class="resident-avatar">
                  <img
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                    :alt="resident.name"
                    class="avatar-image"
                  />
                  <div
                    class="avatar-status"
                    :class="{ online: resident.existPrescription }"
                  ></div>
                </div>

                <div class="resident-info">
                  <h3 class="resident-name">{{ resident.name }}</h3>
                  <p class="resident-nickname" v-if="resident.nickname">
                    {{ resident.nickname }}
                  </p>
                  <p
                    class="resident-age"
                    v-if="resident.date_of_birth && $store.state.online"
                  >
                    {{ getAge(resident.date_of_birth) }} anos
                  </p>

                  <p
                    class="resident-with-prescription"
                    v-if="resident.existPrescription"
                  >
                    Com prescrição normal
                  </p>
                  <p
                    class="resident-without-prescription"
                    v-if="!resident.existPrescription"
                  >
                    Sem prescrição normal
                  </p>

                  <p
                    class="resident-with-prescription"
                    v-if="resident.existPrescriptionLongTerm"
                  >
                    Com prescrição longo prazo
                  </p>
                </div>
              </div>

              <!-- Alerts Section -->
              <div class="alerts-section" v-if="$store.state.online">
                <!-- Pending Medications -->
                <div
                  v-if="resident.pendingChecks.length > 0"
                  class="alert-item alert-critical"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-capsules"></i>
                        <span>Medicamentos Atrasados</span>
                        <span class="badge-count">{{
                          resident.pendingChecks.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos Pendentes</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecks"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- Pending Care -->
                <div
                  v-if="resident.pendingCares.length > 0"
                  class="alert-item alert-warning"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-exclamation"></i>
                        <span>Cuidados Pendentes</span>
                        <span class="badge-count">{{
                          resident.pendingCares.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Cuidados Pendentes</h6>
                      <div
                        v-for="(item, key) in resident.pendingCares"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-type">
                            {{
                              item.type == "ANNOTATION"
                                ? "ANOTAÇÃO"
                                : "SINAIS VITAIS"
                            }}
                          </p>
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="handleToUserCare(resident.id, item.created)"
                          class="tooltip-action"
                        >
                          Acessar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- Pending Semiology -->
                <div
                  v-if="resident.pendingSemiology.length > 0"
                  class="alert-item alert-info"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-edit"></i>
                        <span>Semiologia</span>
                        <span class="badge-count">{{
                          resident.pendingSemiology.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Formulários Pendentes</h6>
                      <div
                        v-for="(item, key) in resident.pendingSemiology"
                        :key="key"
                        class="tooltip-item"
                      >
                        <div class="care-info">
                          <p class="care-date">
                            {{
                              String(item.created)
                                .split("-")
                                .reverse()
                                .join("/")
                            }}
                          </p>
                          <p class="care-caregiver">{{ item.user_name }}</p>
                        </div>
                        <button
                          @click="
                            handleToResidentBySemiology(
                              resident.id,
                              item.created
                            )
                          "
                          class="tooltip-action"
                        >
                          Finalizar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- Long Term Medications -->
                <div
                  v-if="resident.pendingChecksLongTerm.length > 0"
                  class="alert-item alert-success"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-clock"></i>
                        <span>Longo Prazo</span>
                        <span class="badge-count">{{
                          resident.pendingChecksLongTerm.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Medicamentos de Longo Prazo</h6>
                      <div
                        v-for="(item, key) in resident.pendingChecksLongTerm"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          formatDate(item.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(resident.id, item.date)
                          "
                          class="tooltip-action"
                        >
                          Checar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- Advance Notifications -->
                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_separate > 0
                  "
                  class="alert-item alert-primary"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-pills"></i>
                        <span>Separar Medicação</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Separar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <div
                  v-if="
                    resident.advanceNotification.data &&
                    resident.advanceNotification.count_check > 0
                  "
                  class="alert-item alert-primary"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-syringe"></i>
                        <span>Administrar Medicação</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <div class="tooltip-item">
                        <span class="tooltip-date">{{
                          formatDate(resident.advanceNotification.date, false)
                        }}</span>
                        <button
                          @click="
                            handleToResidentByCheck(
                              resident.id,
                              resident.advanceNotification.date
                            )
                          "
                          class="tooltip-action"
                        >
                          Administrar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>

                <!-- Appointments today -->
                <div
                  v-if="resident.schedules.length > 0"
                  class="alert-item alert-info"
                >
                  <tippy
                    arrow
                    theme="light"
                    trigger="click"
                    interactive
                    placement="bottom"
                  >
                    <template v-slot:trigger>
                      <div class="alert-badge">
                        <i class="fas fa-calendar"></i>
                        <span>Agendamentos com data de hoje</span>
                        <span class="badge-count">{{
                          resident.schedules.length
                        }}</span>
                      </div>
                    </template>
                    <div class="tooltip-content">
                      <h6 class="tooltip-title">Agendamentos</h6>
                      <div
                        v-for="(item, key) in resident.schedules"
                        :key="key"
                        class="tooltip-item"
                      >
                        <span class="tooltip-date">{{
                          item.schedule_type_name
                        }}</span>
                        <button
                          @click="
                            directToCalendar(
                              item.resident_id,
                              item.schedule_type_id
                            )
                          "
                          class="tooltip-action"
                        >
                          Verificar
                        </button>
                      </div>
                    </div>
                  </tippy>
                </div>
              </div>

              <!-- No Prescription Message -->
              <div v-if="!resident.existPrescription" class="no-prescription">
                <i class="fas fa-info-circle"></i>
                <span>Não possui prescrição normal ativa</span>
              </div>
            </div>
          </div>

          <!-- No Results -->
          <div
            v-if="!loading && residents.length == 0 && errors.length == 0"
            class="no-results"
          >
            <i class="fas fa-search no-results-icon"></i>
            <h3 class="no-results-title">Nenhum residente encontrado</h3>
            <p class="no-results-text">
              Tente ajustar os filtros para encontrar resultados
            </p>
          </div>

          <!-- Error Messages -->
          <ErrorsMessages :errors="errors" />
        </b-overlay>
      </div>

      <!-- Pagination -->
      <div
        class="pagination-section"
        v-if="!loading && residents.length > 0 && $store.state.online"
      >
        <b-pagination
          v-model="page"
          :total-rows="total"
          :per-page="itemsPerPage"
          @input="getResidents()"
          class="modern-pagination"
          align="center"
        />
      </div>

      <!-- Offline Button -->
      <v-btn
        v-if="$route.query.dataOffline"
        @click="dataOffline"
        class="offline-btn"
        color="primary"
        fixed
        bottom
        right
        fab
      >
        <i class="fas fa-download"></i>
      </v-btn>
    </div>

    <Terms v-if="terms == 0" />

    <TermsGeolocation
      v-if="terms == 1 && geolocation == 1 && terms_geolocation == 0"
    />

    <ConfirmationReading
      @reload="reloadPage"
      :docsToRead="docsToRead"
      :onClose="false"
    />
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import Duty from "../templates/Dashboard/Duty";

import Terms from "../templates/User/terms";

import TermsGeolocation from "../templates/User/TermsGeolocation";

import api from "../services/api";

import { getAge } from "../lib/getAgeByDate";

import { formatDate, formatDateToUs } from "../lib/format";

import routes from "../routes";

import permission from "../lib/permission";

import { get } from "idb-keyval";

import { getStatic, userData } from "../lib/functions";

import APICache from "../lib/api-cache";

import ConfirmationReading from "../templates/DocsFolder/ConfirmationReading";

export default {
  name: "Dashboard",

  components: {
    NavBar,
    AuthBySessionExpired,
    Duty,
    ErrorsMessages,
    Terms,
    TermsGeolocation,
    ConfirmationReading,
  },

  data() {
    return {
      docsToRead: [],

      duty: null,

      terms: 0,

      terms_geolocation: 0,

      geolocation: 0,

      rest_home_finance: 0,

      page: 1,

      total: 0,

      itemsPerPage: 25,

      name: "",

      gender: "NONE",

      filterCare: "NONE",

      degree_of_dependence_id: "NONE",

      filter: [],

      residents: [],

      user: {},

      missing_security_questions: false,

      typesFilterByCare: [
        { value: "NONE", text: "Todos os residentes" },
        { value: "USER", text: "Cuidados cadastrados por mim" },
        { value: "ALL", text: "Todos com cuidados pendentes" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();

    this.checkPeriodDuty();

    this.getDocsToRead();
  },

  methods: {
    userData,

    permission,

    formatDate,

    formatDateToUs,

    getAge,

    async missingSecurityQuestions() {
      try {
        const response = await api.get("/rest-home/users/offline-access");
        const { error, users } = response.data;
        if (!error) {
          const { id } = await get("user");
          this.missing_security_questions = !users.some(
            (user) => user.id == id
          );
        }
      } catch (error) {
        console.log(error);
        this.missing_security_questions = false;
      }
    },

    handleFilterByCare() {
      let {
        filterCare,
        filter,
        user: { id },
      } = this;
      let residents = filter;
      if (filterCare == "ALL") {
        residents = filter.filter((obj) => obj.pendingCares.length > 0);
      }
      if (filterCare == "USER") {
        residents = filter.filter(
          (obj) =>
            obj.pendingCares.length > 0 &&
            obj.pendingCares.filter((p) => String(p.user_id).indexOf(id)) > -1
        );
      }
      this.residents = residents;
    },

    async retrieve() {
      let { user } = userData();
      this.user = user;
      let { rest_home_finance, terms, terms_geolocation, geolocation } = user;
      this.terms = terms;
      this.terms_geolocation = terms_geolocation;
      this.geolocation = geolocation;
      if (rest_home_finance == 1) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (permission("read", "only_financial")) {
        routes.push({ name: "financial", query: { nav: "overview" } });
        return;
      }
      if (this.$store.state.online) {
        if (terms == 1) {
          let sisclindashgender = localStorage.getItem("sisclindashgender");
          if (["NONE", "FEMININO", "MASCULINO"].includes(sisclindashgender)) {
            this.gender = sisclindashgender;
          }
          this.getResidents();
          this.offlineResidents();
        }
        this.missingSecurityQuestions();
      } else {
        try {
          let { residents } = await getStatic("/offline/residents", true);
          let dataResidents = [];
          for (let resident of residents) {
            resident.advanceNotification = { data: false, date: false };
            resident.date_of_birth = null;
            resident.pendingCares = [];
            resident.pendingChecks = [];
            resident.pendingChecksLongTerm = [];
            resident.pendingSemiology = [];
            if (resident.rest_home_id == user.rest_home_id) {
              dataResidents.push(resident);
            }
          }
          this.residents = dataResidents;
        } catch (errors) {
          console.log(errors);
        }
      }
    },

    async offlineResidents() {
      try {
        let residents_cached = localStorage.getItem("residents_cached");
        let { user } = this;
        if (!residents_cached || residents_cached != user.rest_home_id) {
          let response = await api.get("/offline/residents");
          const { error } = response.data;
          if (!error) {
            APICache.cache("/offline/residents", "dynamic", response.data);
            localStorage.setItem("residents_cached", user.rest_home_id);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getResidents() {
      try {
        this.loading = true;
        let { page, itemsPerPage, name, degree_of_dependence_id, gender } =
          this;
        let params = {
          page,
          itemsPerPage,
          name,
          degree_of_dependence_id,
          gender,
        };
        const response = await api.get("/rest-home/resident/dashboard", {
          params,
        });
        const { residents, error, errors, total } = response.data;
        if (error) {
          this.errors = errors;
        } else {
          this.filter = residents;
          this.residents = residents;
          this.total = total;
          this.errors = [];
        }
        localStorage.setItem("sisclindashgender", gender);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async dataOffline() {
      try {
        await api.get("/offline/residents");
        await api.get("/offline/residents/annotations");
        await api.get("/offline/residents/vital-signs");
        await api.get("/offline/residents/checks");
        await api.get("/offline/residents/prescriptions-normal");
        await api.get("/offline/residents/prescriptions-long-term");
      } catch (error) {
        console.log(error);
      }
    },

    async checkPeriodDuty() {
      try {
        const response = await api.get("/rest-home/duty-control/period");

        const { duty } = response.data;

        this.duty = duty;
      } catch (error) {
        console.log(error);
      }
    },

    async getDocsToRead() {
      try {
        const response = await api.get("/folder/user/read-doc");

        const { docsToRead, error } = response.data;

        if (!error) {
          this.docsToRead = docsToRead;

          if (docsToRead && Object.keys(docsToRead).length > 0) {
            this.$nextTick(() => {
              this.$bvModal.show(`ConfirmationReading-${this.docsToRead.id}`);
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    reloadPage() {
      window.location.reload();
    },

    openModal() {
      this.$bvModal.show("confirmationsOfDutys");
    },

    handleToResident: (id) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check" },
      }),

    handleToResidentByCheck: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "check", date: formatDateToUs(date) },
      }),

    directToCalendar: (resident_id, schedule_type_id) =>
      routes.push({
        name: "schedule",
        query: {
          tab: "check",
          nav: "check",
          resident_id,
          schedule_type_id,
        },
      }),

    handleToUserCare: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "check", nav: "annotation", date: formatDateToUs(date) },
      }),

    handleToResidentBySemiology: (id, date) =>
      routes.push({
        name: "resident",
        params: { id },
        query: { tab: "semiology", date: formatDateToUs(date) },
      }),
  },
};
</script>

<style scoped>
.dashboard-modern {
  min-height: 100vh;
  background-color: #f8fafc;
}

.dashboard-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.dashboard-header {
  padding: 12px 0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.header-stats {
  display: flex;
  align-items: center;
  gap: 24px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
}

.stat-label {
  font-size: 14px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Security Alert */
.security-alert {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
  border-radius: 12px;
  padding: 16px;
}

.alert-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.alert-icon {
  color: #d97706;
  font-size: 20px;
}

.alert-text {
  flex: 1;
  color: #92400e;
  font-weight: 500;
}

.alert-button {
  background: #f59e0b;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.alert-button:hover {
  background: #d97706;
  transform: translateY(-1px);
}

/* Filters Section */
.filters-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.filter-icon {
  color: #6b7280;
  font-size: 14px;
}

/* Residents Grid */
.residents-section {
  margin-bottom: 32px;
}

.loading-overlay {
  border-radius: 16px;
}

.residents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 24px;
}

/* Resident Card */
.resident-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.resident-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  border-color: #0f65b0;
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
}

.resident-avatar {
  position: relative;
}

.avatar-image {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e5e7eb;
}

.avatar-status {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 3px solid white;
  background: #ef4444;
}

.avatar-status.online {
  background: #10b981;
}

.resident-info {
  flex: 1;
}

.resident-name {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.3;
}

.resident-nickname {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 4px 0;
  font-style: italic;
}

.resident-age {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.resident-with-prescription {
  font-size: 14px;
  color: #10b981;
  margin: 0;
  font-weight: 500;
}

.resident-without-prescription {
  font-size: 14px;
  color: #ef4444;
  margin: 0;
  font-weight: 500;
}

/* Alerts Section */
.alerts-section {
  margin-bottom: 0px;
}

.alert-item {
  margin-bottom: 2px;
}

.alert-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.alert-primary,
.alert-success,
.alert-warning,
.alert-critical,
.alert-info {
  background-color: transparent;
}

.alert-critical .alert-badge {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.alert-warning .alert-badge {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  color: #d97706;
  border: 1px solid #f59e0b;
}

.alert-info .alert-badge {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
  border: 1px solid #60a5fa;
}

.alert-success .alert-badge {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.alert-primary .alert-badge {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  color: #4338ca;
  border: 1px solid #818cf8;
}

.badge-count {
  background: rgba(255, 255, 255, 0.9);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 700;
  margin-left: 4px;
}

.alert-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Tooltip Content */
.tooltip-content {
  max-width: 300px;
}

.tooltip-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 12px;
  text-align: center;
}

.tooltip-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  margin-bottom: 8px;
}

.tooltip-item:last-child {
  margin-bottom: 0;
}

.tooltip-date {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}

.tooltip-action {
  background: #0f65b0;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.tooltip-action:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.care-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.care-type,
.care-date,
.care-caregiver {
  font-size: 12px;
  margin: 0;
}

.care-type {
  font-weight: 600;
  color: #1e293b;
}

.care-date {
  color: #6b7280;
}

.care-caregiver {
  color: #64748b;
}

/* No Prescription */
.no-prescription {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 8px;
  color: #6b7280;
  font-size: 14px;
}

/* No Results */
.no-results {
  text-align: center;
  padding: 64px 24px;
  color: #6b7280;
}

.no-results-icon {
  font-size: 48px;
  color: #d1d5db;
  margin-bottom: 16px;
}

.no-results-title {
  font-size: 20px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.no-results-text {
  font-size: 16px;
  color: #6b7280;
}

/* Pagination */
.pagination-section {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

/* Offline Button */
.offline-btn {
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 0 16px;
  }

  .dashboard-header {
    padding: 24px 0;
  }

  .dashboard-title {
    font-size: 24px;
  }

  .header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .filters-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .residents-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .resident-card {
    padding: 20px;
  }

  .alert-badge {
    font-size: 11px;
    padding: 6px 10px;
  }
}

@media (max-width: 480px) {
  .card-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
  }

  .resident-info {
    text-align: center;
  }

  .tooltip-item {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
  }

  .tooltip-action {
    align-self: stretch;
    text-align: center;
  }
}

/* Custom Vuetify overrides */
.modern-select >>> .v-input__control,
.modern-input >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-select__selection,
.modern-input >>> .v-text-field__slot input {
  font-weight: 500 !important;
}

.modern-pagination >>> .page-item.active .page-link {
  background-color: #0f65b0;
  border-color: #0f65b0;
  color: #fff;
  border-radius: 5px !important;
}

.modern-pagination >>> .page-link {
  border-radius: 8px;
  margin: 0 2px;
  border: 2px solid #e5e7eb;
  border-radius: 5px !important;
  color: #374151;
}

.modern-pagination >>> .page-link:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-finish-modern {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}
</style>